export default __webpack_public_path__ + "static/slider_3-9ca339724bacc71638f8d43eb89ddaaf.png";